import toastMessage from "../../utils/toastMessage";
import language from "../../language";
import formatDropdownData from "../../utils/formatDropdownData";
import axios from "axios";
import { getStorage } from "../../utils/storage";
import api from "../../utils/api";

export const fetchMerchantVerifications = async (lng = "english", params) => {
  const { listType } = params || {};
  const { accessToken } = await getStorage();

  try {
    let headers = {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: "Bearer " + accessToken,
    };

    const options = {
      method: "GET",
      url: `${api("profile")}/verifications`,
      data: null, //force axios send headers content type
      headers,
    };

    const data = await axios(options);

    if (listType === "dropdown") {
      return formatDropdownData(data.data, "name", "id");
    }

    return data.data;
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_verifications);
  }
};
